import React from "react";

import cx from "./cx";

export type BadgeVariant =
  | "default"
  | "secondary"
  | "destructive"
  | "outline"
  | "none";

const baseClass =
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2";

const variantClass: Record<BadgeVariant, string> = {
  default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
  secondary:
    "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
  destructive:
    "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
  outline: "text-foreground",
  none: "border-transparent",
};

type Props = React.HTMLAttributes<HTMLDivElement> & {
  variant?: BadgeVariant;
};

const Badge = ({ className, variant = "default", ...props }: Props) => (
  <div className={cx(baseClass, variantClass[variant], className)} {...props} />
);

export { Badge };
export default Badge;
